import { $api } from './api';

export const useWarehouses = () => {
  const {
    data: warehouses,
    isLoading,
    isFetching,
    isError,
    error,
  } = $api.useQuery('get', '/stock/warehouse/warehouse/');

  return {
    warehouses,
    isLoading,
    isFetching,
    isError,
    error,
  };
};
